import debounce from 'debounce';
import $ from 'jquery';
import { createMap, getExtraLayers, onChooseSitesMapCreated } from 'map';
import { onAddRoute, onModifySection } from 'map-callbacks';
import { Stroke, Style } from 'ol/style';

/*global OLUtils */

function saveGeometries() {
    const geometries = vdMap.getGeometries();
    const caseMap = new Map();

    // Reset all previous geometries
    $('input[name$=".geometry"]').val('');

    // Group new geometries by site
    geometries.forEach(geometry => {
        const p = geometry.getProperties();
        const siteMap = caseMap.has(p.caseIndex)
            ? caseMap.get(p.caseIndex)
            : caseMap.set(p.caseIndex, new Map()).get(p.caseIndex);
        const geometryList = siteMap.has(p.siteIndex)
            ? siteMap.get(p.siteIndex)
            : siteMap.set(p.siteIndex, []).get(p.siteIndex);
        geometryList.push(geometry);
    });

    // Save new geometries
    caseMap.forEach((siteMap, caseIndex) => {
        caseIndex = caseIndex || 0;
        siteMap.forEach((g, siteIndex) => {
            let wkt = OLUtils.WKT.writeFeatures(g);
            // Oracle doesn't seem to support empty.
            if (wkt.indexOf("EMPTY") > -1) {
                wkt = "";
            }
            if (siteIndex === undefined) {
                $(`input[name='caseSetBean.cases[${caseIndex}].geometry']`).val(wkt);
            } else {
                $(`input[name='caseSetBean.cases[${caseIndex}].sites[${siteIndex}].geometry']`).val(wkt);
            }
        })
    });
}

$(() => {
    const modes = ['selectRoute', 'modifySection', 'drawPolygon', 'deletePolygon', 'dirInfo', 'streetView'];
    const handlers = {
        addRouteCallback: onAddRoute,
        modifySectionCallback: onModifySection
    };

    getExtraLayers(authority)
        .then(layers => createMap('mapElement', null, modes, handlers, layers))
        .then(vdMap => {
            //TODO: migrate all site geometry to case geometry
            //TODO: make sure case geometry is displayed
            //TODO: save case geometry on edit
            // or what? we don't want to destroy non-user-drawn site geometries

            onChooseSitesMapCreated(vdMap);

            vdMap.map.getLayerGroup().on('change', debounce(saveGeometries, 500));

            const style = new Style({
                stroke: new Stroke({
                    color: 'blue',
                    width: 4
                })
            });
            vdMap.geometryOverlay.setStyle(style);
        });
});
